import PropTypes from "prop-types";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { animateScroll } from "react-scroll";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import FooterCopyright from "../../components/footer/FooterCopyright";
import FooterNewsletter from "../../components/footer/FooterNewsletter";
import { getMultiLangProperty } from "../../../helpers/generalHelper";

const FooterOne = ({
  backgroundColorClass,
  spaceTopClass,
  spaceBottomClass,
  containerClass,
  extraFooterClass,
  sideMenu,
}) => {
  const { t, i18n } = useTranslation();

  const storeConfig = useSelector((state) => state.storeConfig);

  const [scroll, setScroll] = useState(0);
  const [top, setTop] = useState(0);
  const [content, setContent] = useState({});

  useEffect(() => {
    setContent(storeConfig);

    setTop(100);
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [storeConfig]);

  const scrollToTop = () => {
    animateScroll.scrollToTop();
  };

  const handleScroll = () => {
    setScroll(window.scrollY);
  };

  return (
    <footer
      className={`footer-area ${backgroundColorClass || ""} ${
        spaceTopClass || ""
      } ${spaceBottomClass || ""} ${extraFooterClass || ""}`}
    >
      <div className={`${containerClass || "container"}`}>
        <div className="row">
          <div
            className={`${
              sideMenu ? "col-xl-4 col-sm-4" : "col-lg-4 col-sm-5"
            }`}
          >
            {/* footer copyright */}
            {(content.logo || content.siteTitle) && (
              <FooterCopyright
                footerLogo={content.logo?.fileUrl}
                footerName={getMultiLangProperty(
                  content.siteTitle,
                  i18n.language
                )}
                footerContact={content.contact || []}
                spaceBottomClass="mb-30"
              />
            )}
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-2 col-sm-4" : "col-lg-2 col-sm-3"
            }`}
          >
            <div className="footer-widget mb-30 ml-30">
              <div className="footer-title">
                <h3>{t("footer.aboutus")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  {Array.isArray(content.aboutUsLink) &&
                    content.aboutUsLink.map((item, index) => (
                      <li key={`about_link_${index}`}>
                        <a href={getMultiLangProperty(item.url, i18n.language)}>
                          {getMultiLangProperty(item.name, i18n.language)}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-4 col-sm-4" : "col-lg-3 col-sm-4"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
              }`}
            >
              <div className="footer-title">
                <h3>{t("footer.usefulLinks")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  {Array.isArray(content.usefulLink) &&
                    content.usefulLink.map((item, index) => (
                      <li key={`usefulLink_${index}`}>
                        <a href={getMultiLangProperty(item.url, i18n.language)}>
                          {getMultiLangProperty(item.name, i18n.language)}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-4 col-sm-4" : "col-lg-3 col-sm-4"
            }`}
          >
            <div
              className={`${
                sideMenu
                  ? "footer-widget mb-30 ml-95"
                  : "footer-widget mb-30 ml-50"
              }`}
            >
              <div className="footer-title">
                <h3>{t("footer.subscribeUs")}</h3>
              </div>
              <div className="footer-list">
                <ul>
                  {Array.isArray(content.socialLink) &&
                    content.socialLink.map((item, index) => (
                      <li key={`usefulLink_${index}`}>
                        <a
                          href={getMultiLangProperty(item.url, i18n.language)}
                          target="_blank"
                          rel="noopener noreferrer"
                        >
                          {getMultiLangProperty(item.name, i18n.language)}
                        </a>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
          <div
            className={`${
              sideMenu ? "col-xl-4 col-sm-4" : "col-lg-3 col-sm-4"
            }`}
            style={{ color: "grey" }}
          >
            {`Version: ${process.env.REACT_APP_VERSION}`}
          </div>
          <div
            style={{ display: "none" }}
            className={`${
              sideMenu ? "col-xl-3 col-sm-8" : "col-lg-4 col-sm-6"
            }`}
          >
            {/* footer newsletter */}
            <FooterNewsletter
              spaceBottomClass="mb-30"
              spaceLeftClass="ml-70"
              sideMenu={sideMenu}
            />
          </div>
        </div>
      </div>
      <button
        className={`scroll-top ${scroll > top ? "show" : ""}`}
        onClick={() => scrollToTop()}
      >
        <i className="fa fa-angle-double-up" />
      </button>
    </footer>
  );
};

FooterOne.propTypes = {
  backgroundColorClass: PropTypes.string,
  containerClass: PropTypes.string,
  extraFooterClass: PropTypes.string,
  sideMenu: PropTypes.bool,
  spaceBottomClass: PropTypes.string,
  spaceTopClass: PropTypes.string,
};

export default FooterOne;
